/** Build StartTest API path; include browser-stored Test code so the API can fork vs resume. */
export function startTestPath(code: string, storedCode?: string | null): string {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  const encoded = encodeURIComponent(code);
  const params = new URLSearchParams();
  if (timeZone) params.set("timeZone", timeZone);
  const trimmedStored = String(storedCode || "").trim();
  if (trimmedStored) params.set("storedCode", trimmedStored);
  const query = params.toString();
  return query ? `/StartTest/${encoded}?${query}` : `/StartTest/${encoded}`;
}
